"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('two-hands', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, _react.default.createElement("path", {
    d: "M37 19.9756L36.0174 23.9332L27.3116 30.2402L27.3616 41.9575L34 42.0001L33.6274 33.5146C40.5488 29.1858 44.0095 26.0143 44.0095 24.0001C44.0095 21.9859 44.0095 16.6721 44.0095 6.05867",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M11 20.0509L12.0331 24.0002L20.4005 30.4158L20.7595 42.1278L14 42.0002L14.2029 33.9086C7.40934 30.0008 4.01257 27.025 4.01257 24.9811C4.01257 22.9373 4.01257 17.2866 4.01257 6.0291",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  })));
});

exports.default = _default;